import { useState } from "react";
import axiosInstance from "@/hooks/axios";
import { isAxiosError } from "axios";

export interface LogoutUserResponse {
  success: boolean;
  message: string;
}

export const useLogoutUser = () => {
  const [data, setData] = useState<LogoutUserResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const logoutUser = async (refreshToken: string) => {
    setLoading(true);
    setError(null);
    try {
      const response = await axiosInstance.post<LogoutUserResponse>(
        "users/users/logout/",
        { refresh_token: refreshToken },
      );
      setData(response.data);
    } catch (err: unknown) {
      if (isAxiosError(err)) {
        setError(err.message);
      } else if (err instanceof Error) {
        setError(err.message);
      } else {
        setError("An unknown error occurred.");
      }
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, logoutUser };
};
